import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import Home from './pages/Home.tsx';
import SignInConfirmation from './pages/SignInConfirmation.tsx';
import Callback from './pages/Callback.tsx';
import './App.css';

function App(): JSX.Element {
    const { isLoading, error, getAccessTokenSilently, isAuthenticated } = useAuth0();

    useEffect(() => {
        // Always try to refresh auth state on app load
        const refreshAuth = async () => {
            if (!isAuthenticated && !isLoading) {
                try {
                    await getAccessTokenSilently({ cacheMode: 'off' });
                    console.log('Auth state refreshed');
                } catch (error) {
                    // This is expected if user is not authenticated
                    console.log('No valid authentication found');
                }
            }
        };

        // Small delay to let initial auth check complete
        setTimeout(refreshAuth, 500);
    }, [getAccessTokenSilently, isAuthenticated, isLoading]);

    if (error && !window.location.pathname.includes('/callback')) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div>Authentication Error: {error.message}</div>
            </div>
        );
    }

    if (isLoading && !window.location.pathname.includes('/callback')) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/signin-confirmation" element={<SignInConfirmation />} />
        </Routes>
    );
}

export default App;